import callNativeMobileApp from './callNativeMobileApp';

export default function callNativeAppInfo() {
  callNativeMobileApp({
    action: 'request_app_info',
  });
}
